// Turf types - canvassing territory management

import type { GeoJSONPolygon } from './geo';

export enum TurfStatus {
  Unassigned = 'Unassigned',
  Assigned = 'Assigned',
  InProgress = 'InProgress',
  Completed = 'Completed',
}

export interface Turf {
  id: string;
  name: string;
  polygon: GeoJSONPolygon;
  houseCount: number;
  voterCount: number;
  shiftId?: string;
  teamId?: string;
  volunteerIds: string[];
  doorsKnocked: number;
  totalDoors: number;
  createdAt: string;
  isArchived: boolean;
}
